import { Component, OnInit } from '@angular/core';
import { User } from '../../_models/user';
import { Globals } from '../../_models/globals';
import { AlertService } from '../../_services/alert.service';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { ApiIntegration } from '../../_services/api.integration';
import * as moment from 'moment';
import { DatePipe } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-finance-cod-orders-payment-processing',
  templateUrl: './finance-cod-orders-payment-processing.component.html',
  styleUrls: ['./finance-cod-orders-payment-processing.component.scss'],
  providers: [DatePipe]
})
export class FinanceCodOrdersPaymentProcessingComponent implements OnInit {

  transactionNo: string;
  transactionNumberError: string;
  accountOName: string;
  transactionDate: string;
  transactionDateError: string;
  trDate: string;
  ordersId: any;
  amount: any;
  sum: number = 0;


  constructor(private datePipe: DatePipe, public user: User, private router: Router, public g: Globals, private alertService: AlertService, private http: HttpClient, private api: ApiIntegration) {
    this.accountOName = this.user.accountOwnerName;
    console.log(this.g.ordersIds);
    console.log(this.g.amountValues);


    for (let i = 0; i < this.g.amountValues.length; i++) {
      let temp: any;
      temp = this.g.amountValues[i];
      this.sum = this.sum + temp;
      console.log(this.g.amountValues[i]);
    }
    console.log(this.sum);
  }

  ngOnInit() { }


  typeTransactionNo() {
    this.transactionNumberError = '';
    if (this.transactionNo == '' || this.transactionNo === null || this.transactionNo === undefined || this.transactionNo === 'undefined') {
      this.transactionNumberError = 'Please enter the transaction ref number'
    }
  }

  typeTranDate() {
    this.transactionDateError = '';
    if (this.transactionDate == '' || this.transactionDate === null || this.transactionDate === undefined || this.transactionDate === 'undefined') {
      this.transactionDateError = "Please select the date"
    }

  }

  //endDate = moment(this.endDate).format("MM/DD/YYYY");


  saveCodInfo() {
    this.g.loaderDisplay = "display";
    this.trDate = this.datePipe.transform(this.transactionDate, 'MM/dd/yyyy');
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/savePaymentInfoForCODOrder', {
      "orderAmount": this.sum,
      "orderNumber": this.g.ordersIds,
      "remittanceRefDate": this.trDate,
      "remittanceRefNum": this.transactionNo,
    },
      { headers: header1 }).subscribe((data: any) => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Cod Info', 'Saved Successfully');
          this.router.navigate(['/admin/financeCODOrdersList']);
        } else {
          this.alertService.error('Error', data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
        });
  }


}
